import { STATIC_ASSETS_PLACEHOLDER } from "../staticAssetsPlaceholder.js";
const bezierConfig = { p0: 0.68, p1: -0.2, p2: 0.32, p3: 1.2 };
const greetingLinesAsScenesSceneBackground = {
    variant: "insetBox",
    padding: "4%",
    borderRadius: "4rem",
    boxColor: ["#dbbe8fb3", "#91a0b6b3"],
    opacity: 1,
};
const images = {
    bubble_blue_1: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/star-pop/bubble_blue_1.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/star-pop/optimized/bubble_blue_1.webp`,
        width: 104,
        height: 100,
    },
    bubble_blue_2: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/star-pop/bubble_blue_2.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/star-pop/optimized/bubble_blue_2.webp`,
        width: 72,
        height: 68,
    },
    bubble_gold_1: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/star-pop/bubble_gold_1.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/star-pop/optimized/bubble_gold_1.webp`,
        width: 50,
        height: 50,
    },
    bubble_gold_2: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/star-pop/bubble_gold_2.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/star-pop/optimized/bubble_gold_2.webp`,
        width: 103,
        height: 103,
    },
    star_gold_1: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/star-pop/star_gold_1.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/star-pop/optimized/star_gold_1.webp`,
        width: 259,
        height: 262,
    },
    star_gold_2: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/star-pop/star_gold_2.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/star-pop/optimized/star_gold_2.webp`,
        width: 261,
        height: 268,
    },
    star_gold_3: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/star-pop/star_gold_3.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/star-pop/optimized/star_gold_3.webp`,
        width: 216,
        height: 232,
    },
    star_silver_1: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/star-pop/star_silver_1.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/star-pop/optimized/star_silver_1.webp`,
        width: 165,
        height: 170,
    },
    star_silver_2: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/star-pop/star_silver_2.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/star-pop/optimized/star_silver_2.webp`,
        width: 169,
        height: 169,
    },
};
const messageAssets = [
    [
        {
            url: images.star_gold_1,
            style: {
                zIndex: 10,
                translate: "-42% -47%",
                rotate: "45deg",
                scale: "0.05",
            },
            rotateNudgeOptions: {
                min: -10,
                max: 10,
            },
        },
        {
            url: images.star_gold_2,
            style: {
                zIndex: 10,
                translate: "45% -8%",
                rotate: "45deg",
                scale: "0.05",
            },
            rotateNudgeOptions: {
                min: -10,
                max: 10,
            },
        },
        {
            url: images.star_silver_1,
            style: {
                zIndex: 10,
                translate: "38% 0%",
                rotate: "20deg",
                scale: "0.07",
            },
            rotateNudgeOptions: {
                min: -10,
                max: 10,
            },
        },
    ],
    [
        {
            url: images.star_gold_2,
            style: {
                zIndex: 10,
                translate: "20% -47%",
                rotate: "20deg",
                scale: "0.05",
            },
            rotateNudgeOptions: {
                min: -10,
                max: 10,
            },
        },
        {
            url: images.star_gold_1,
            style: {
                zIndex: 10,
                translate: "38% 0%",
                rotate: "-5deg",
                scale: "0.07",
            },
            rotateNudgeOptions: {
                min: -10,
                max: 10,
            },
        },
    ],
    [
        {
            url: images.star_gold_1,
            style: {
                zIndex: 10,
                translate: "-42% -47%",
                rotate: "45deg",
                scale: "0.05",
            },
            rotateNudgeOptions: {
                min: -10,
                max: 10,
            },
        },
        {
            url: images.star_gold_2,
            style: {
                zIndex: 10,
                translate: "45% -8%",
                rotate: "45deg",
                scale: "0.05",
            },
            rotateNudgeOptions: {
                min: -10,
                max: 10,
            },
        },
        {
            url: images.star_silver_1,
            style: {
                zIndex: 10,
                translate: "38% 0%",
                rotate: "20deg",
                scale: "0.07",
            },
            rotateNudgeOptions: {
                min: -10,
                max: 10,
            },
        },
    ],
];
export const starPop = {
    version: 1,
    themeId: "star-pop",
    name: "Star Pop",
    endFadeDuration: 1,
    thumbnailFrame: 100,
    thumbnailUrl: `${STATIC_ASSETS_PLACEHOLDER}/compilations/theme-stills/star-pop.webp`,
    background: [
        {
            variant: "doodle",
            images: [
                {
                    src: images.bubble_blue_1,
                    displaySize: { width: 26 },
                    enter: {
                        start: {
                            frame: 30,
                            position: { x: 12, y: 3 },
                            rotation: 0,
                            scale: 0,
                        },
                        end: {
                            frame: 45,
                            scale: { value: 2, back: 10 },
                        },
                    },
                    animate: {
                        rotate: 22,
                        translate: { x: 8, y: -15 },
                        scale: 1.3,
                    },
                },
                {
                    src: images.bubble_gold_1,
                    displaySize: { width: 13 },
                    enter: {
                        start: {
                            frame: 12,
                            position: { x: 8, y: 36 },
                            rotation: 0,
                            scale: 0,
                        },
                        end: {
                            frame: 27,
                            scale: { value: 1.7, back: 10 },
                        },
                    },
                    animate: {
                        rotate: 22,
                        translate: { x: 21, y: -23 },
                        scale: 1.1,
                    },
                },
                {
                    src: images.star_silver_1,
                    displaySize: { width: 41 },
                    enter: {
                        start: {
                            frame: 21,
                            position: { x: 4, y: 22 },
                            rotation: 0,
                            scale: 0,
                        },
                        end: {
                            frame: 36,
                            scale: { value: 1.1, back: 10 },
                        },
                    },
                    animate: {
                        rotate: 22,
                        translate: { x: 13, y: 7 },
                        scale: 1.3,
                    },
                },
                {
                    src: images.star_gold_1,
                    displaySize: { width: 65 },
                    enter: {
                        start: {
                            frame: 13,
                            position: { x: 22, y: 30 },
                            rotation: 0,
                            scale: 0,
                        },
                        end: {
                            frame: 28,
                            scale: { value: 1.5, back: 10 },
                        },
                    },
                    animate: {
                        rotate: 24,
                        translate: { x: -12, y: -3 },
                        scale: 1.1,
                    },
                },
                {
                    src: images.bubble_gold_2,
                    displaySize: { width: 26 },
                    enter: {
                        start: {
                            frame: 24,
                            position: { x: 29, y: 3 },
                            rotation: 0,
                            scale: 0,
                        },
                        end: {
                            frame: 39,
                            scale: { value: 2.1, back: 10 },
                        },
                    },
                    animate: {
                        rotate: 21,
                        translate: { x: 11, y: -21 },
                        scale: 1,
                    },
                },
                {
                    src: images.star_silver_2,
                    displaySize: { width: 42 },
                    enter: {
                        start: {
                            frame: 18,
                            position: { x: 35, y: 8 },
                            rotation: 0,
                            scale: 0,
                        },
                        end: {
                            frame: 33,
                            scale: { value: 2.2, back: 10 },
                        },
                    },
                    animate: {
                        rotate: 17,
                        translate: { x: 6, y: 14 },
                        scale: 1.3,
                    },
                },
                {
                    src: images.bubble_blue_2,
                    displaySize: { width: 18 },
                    enter: {
                        start: {
                            frame: 12,
                            position: { x: 50, y: 2 },
                            rotation: 0,
                            scale: 0,
                        },
                        end: {
                            frame: 27,
                            scale: { value: 1.7, back: 10 },
                        },
                    },
                    animate: {
                        rotate: 21,
                        translate: { x: -16, y: 7 },
                        scale: 1.3,
                    },
                },
                {
                    src: images.star_silver_1,
                    displaySize: { width: 41 },
                    enter: {
                        start: {
                            frame: 13,
                            position: { x: 65, y: 0 },
                            rotation: 0,
                            scale: 0,
                        },
                        end: {
                            frame: 28,
                            scale: { value: 1.3, back: 10 },
                        },
                    },
                    animate: {
                        rotate: 20,
                        translate: { x: -3, y: -13 },
                        scale: 1.5,
                    },
                },
                {
                    src: images.bubble_gold_1,
                    displaySize: { width: 13 },
                    enter: {
                        start: {
                            frame: 17,
                            position: { x: 90, y: 3 },
                            rotation: 0,
                            scale: 0,
                        },
                        end: {
                            frame: 32,
                            scale: { value: 1.7, back: 10 },
                        },
                    },
                    animate: {
                        rotate: 16,
                        translate: { x: -4, y: 0 },
                        scale: 1.1,
                    },
                },
                {
                    src: images.star_gold_2,
                    displaySize: { width: 65 },
                    enter: {
                        start: {
                            frame: 19,
                            position: { x: 50, y: 18 },
                            rotation: 0,
                            scale: 0,
                        },
                        end: {
                            frame: 34,
                            scale: { value: 2.5, back: 10 },
                        },
                    },
                    animate: {
                        rotate: 22,
                        translate: { x: 15, y: 1 },
                        scale: 1.1,
                    },
                },
                {
                    src: images.star_gold_3,
                    displaySize: { width: 54 },
                    enter: {
                        start: {
                            frame: 24,
                            position: { x: 95, y: 25 },
                            rotation: 0,
                            scale: 0,
                        },
                        end: {
                            frame: 39,
                            scale: { value: 1.2, back: 10 },
                        },
                    },
                    animate: {
                        rotate: 24,
                        translate: { x: -8, y: -15 },
                        scale: 1.2,
                    },
                },
                {
                    src: images.star_silver_2,
                    displaySize: { width: 42 },
                    enter: {
                        start: {
                            frame: 29,
                            position: { x: 80, y: 15 },
                            rotation: 0,
                            scale: 0,
                        },
                        end: {
                            frame: 44,
                            scale: { value: 2.5, back: 10 },
                        },
                    },
                    animate: {
                        rotate: 22,
                        translate: { x: -7, y: 5 },
                        scale: 1.1,
                    },
                },
                {
                    src: images.star_gold_1,
                    displaySize: { width: 65 },
                    enter: {
                        start: {
                            frame: 25,
                            position: { x: 70, y: 23 },
                            rotation: 0,
                            scale: 0,
                        },
                        end: {
                            frame: 40,
                            scale: { value: 2.5, back: 10 },
                        },
                    },
                    animate: {
                        rotate: 21,
                        translate: { x: -1, y: 1 },
                        scale: 1.2,
                    },
                },
                {
                    src: images.star_silver_1,
                    displaySize: { width: 41 },
                    enter: {
                        start: {
                            frame: 22,
                            position: { x: 0, y: 80 },
                            rotation: 0,
                            scale: 0,
                        },
                        end: {
                            frame: 37,
                            scale: { value: 2.4, back: 10 },
                        },
                    },
                    animate: {
                        rotate: 19,
                        translate: { x: 6, y: -13 },
                        scale: 1.2,
                    },
                },
                {
                    src: images.bubble_blue_2,
                    displaySize: { width: 18 },
                    enter: {
                        start: {
                            frame: 13,
                            position: { x: 0, y: 50 },
                            rotation: 0,
                            scale: 0,
                        },
                        end: {
                            frame: 28,
                            scale: { value: 1.9, back: 10 },
                        },
                    },
                    animate: {
                        rotate: 22,
                        translate: { x: -14, y: 0 },
                        scale: 1.2,
                    },
                },
                {
                    src: images.star_gold_2,
                    displaySize: { width: 65 },
                    enter: {
                        start: {
                            frame: 24,
                            position: { x: 11, y: 90 },
                            rotation: 0,
                            scale: 0,
                        },
                        end: {
                            frame: 39,
                            scale: { value: 2.3, back: 10 },
                        },
                    },
                    animate: {
                        rotate: 19,
                        translate: { x: -12, y: -11 },
                        scale: 1.1,
                    },
                },
                {
                    src: images.star_gold_3,
                    displaySize: { width: 54 },
                    enter: {
                        start: {
                            frame: 15,
                            position: { x: 18, y: 80 },
                            rotation: 0,
                            scale: 0,
                        },
                        end: {
                            frame: 30,
                            scale: { value: 1.5, back: 10 },
                        },
                    },
                    animate: {
                        rotate: 19,
                        translate: { x: 8, y: 8 },
                        scale: 1.2,
                    },
                },
                {
                    src: images.bubble_blue_1,
                    displaySize: { width: 26 },
                    enter: {
                        start: {
                            frame: 27,
                            position: { x: 31, y: 75 },
                            rotation: 0,
                            scale: 0,
                        },
                        end: {
                            frame: 42,
                            scale: { value: 1.9, back: 10 },
                        },
                    },
                    animate: {
                        rotate: 25,
                        translate: { x: 20, y: -8 },
                        scale: 1,
                    },
                },
                {
                    src: images.star_silver_1,
                    displaySize: { width: 42 },
                    enter: {
                        start: {
                            frame: 17,
                            position: { x: 29, y: 95 },
                            rotation: 0,
                            scale: 0,
                        },
                        end: {
                            frame: 32,
                            scale: { value: 1.7, back: 10 },
                        },
                    },
                    animate: {
                        rotate: 25,
                        translate: { x: -7, y: 7 },
                        scale: 1.2,
                    },
                },
                {
                    src: images.star_gold_1,
                    displaySize: { width: 65 },
                    enter: {
                        start: {
                            frame: 15,
                            position: { x: 45, y: 75 },
                            rotation: 0,
                            scale: 0,
                        },
                        end: {
                            frame: 30,
                            scale: { value: 1.8, back: 10 },
                        },
                    },
                    animate: {
                        rotate: 15,
                        translate: { x: 3, y: 0 },
                        scale: 1.4,
                    },
                },
                {
                    src: images.bubble_blue_2,
                    displaySize: { width: 18 },
                    enter: {
                        start: {
                            frame: 22,
                            position: { x: 50, y: 95 },
                            rotation: 0,
                            scale: 0,
                        },
                        end: {
                            frame: 37,
                            scale: { value: 1.6, back: 10 },
                        },
                    },
                    animate: {
                        rotate: 17,
                        translate: { x: -13, y: 6 },
                        scale: 1.3,
                    },
                },
                {
                    src: images.star_silver_1,
                    displaySize: { width: 41 },
                    enter: {
                        start: {
                            frame: 29,
                            position: { x: 65, y: 80 },
                            rotation: 0,
                            scale: 0,
                        },
                        end: {
                            frame: 44,
                            scale: { value: 1.9, back: 10 },
                        },
                    },
                    animate: {
                        rotate: 24,
                        translate: { x: -13, y: 8 },
                        scale: 1.1,
                    },
                },
                {
                    src: images.star_silver_2,
                    displaySize: { width: 42 },
                    enter: {
                        start: {
                            frame: 16,
                            position: { x: 70, y: 95 },
                            rotation: 0,
                            scale: 0,
                        },
                        end: {
                            frame: 31,
                            scale: { value: 2.1, back: 10 },
                        },
                    },
                    animate: {
                        rotate: 21,
                        translate: { x: 13, y: -8 },
                        scale: 1.2,
                    },
                },
                {
                    src: images.bubble_gold_2,
                    displaySize: { width: 26 },
                    enter: {
                        start: {
                            frame: 27,
                            position: { x: 75, y: 68 },
                            rotation: 0,
                            scale: 0,
                        },
                        end: {
                            frame: 42,
                            scale: { value: 2.1, back: 10 },
                        },
                    },
                    animate: {
                        rotate: 16,
                        translate: { x: 14, y: 2 },
                        scale: 1.1,
                    },
                },
                {
                    src: images.star_gold_2,
                    displaySize: { width: 65 },
                    enter: {
                        start: {
                            frame: 14,
                            position: { x: 83, y: 85 },
                            rotation: 0,
                            scale: 0,
                        },
                        end: {
                            frame: 29,
                            scale: { value: 2.2, back: 10 },
                        },
                    },
                    animate: {
                        rotate: 16,
                        translate: { x: -5, y: -4 },
                        scale: 1.1,
                    },
                },
                {
                    src: images.star_silver_1,
                    displaySize: { width: 41 },
                    enter: {
                        start: {
                            frame: 16,
                            position: { x: 90, y: 65 },
                            rotation: 0,
                            scale: 0,
                        },
                        end: {
                            frame: 31,
                            scale: { value: 2.5, back: 10 },
                        },
                    },
                    animate: {
                        rotate: 21,
                        translate: { x: -11, y: 6 },
                        scale: 1.1,
                    },
                },
                {
                    src: images.star_gold_3,
                    displaySize: { width: 54 },
                    enter: {
                        start: {
                            frame: 11,
                            position: { x: 97, y: 80 },
                            rotation: 0,
                            scale: 0,
                        },
                        end: {
                            frame: 26,
                            scale: { value: 1.1, back: 10 },
                        },
                    },
                    animate: {
                        rotate: 23,
                        translate: { x: 12, y: 6 },
                        scale: 1.2,
                    },
                },
                {
                    src: images.bubble_gold_1,
                    displaySize: { width: 13 },
                    enter: {
                        start: {
                            frame: 22,
                            position: { x: 98, y: 98 },
                            rotation: 0,
                            scale: 0,
                        },
                        end: {
                            frame: 37,
                            scale: { value: 1.5, back: 10 },
                        },
                    },
                    animate: {
                        rotate: 23,
                        translate: { x: -14, y: -21 },
                        scale: 1.3,
                    },
                },
            ],
        },
    ],
    scenes: [
        {
            type: "generalSolidIntro",
            durationSeconds: 5,
            transitionVariant: "type-on",
            faceCollage: {
                variant: "top-bottom-static",
                borderShape: "circle",
                startAtSeconds: 1,
                entrance: { variant: "random-pop-in", transitionDurationInFrames: 20 },
            },
            title: {
                fontFamily: "Stint Ultra Expanded",
                fontSize: 150,
                fontWeight: "extralight",
                letterSpacing: "widest",
            },
        },
        {
            type: "greetingLinesAsScenes",
            variant: "intro",
            secondsPerCharacter: 0.1,
            minimumMessageDisplayTimeSeconds: 3,
            showLogo: true,
            sceneBackground: greetingLinesAsScenesSceneBackground,
            messageAssets,
        },
        {
            type: "clip-series-basic",
            showLogo: true,
        },
        {
            type: "greetingLinesAsScenes",
            variant: "outro",
            secondsPerCharacter: 0.1,
            minimumMessageDisplayTimeSeconds: 3,
            sceneBackground: greetingLinesAsScenesSceneBackground,
            messageAssets,
        },
        {
            type: "outro",
            colorVariant: "darkBlue",
        },
    ],
    styles: {
        textBox: {
            backgroundColor: "#fff",
            backgroundOpacity: 0,
            backgroundBlur: 2,
            textAlign: "center",
            textColor: "white",
            fontFamily: "Stint Ultra Condensed",
            fontWeight: "light",
            fontSize: 140,
            leading: 1.1,
            tracking: 0,
        },
        clips: {
            textVariant: {
                variant: "slide-in-static",
                entranceVariant: "slide-to-flush-left",
                startOffsetSeconds: 0.6,
                cards: [
                    {
                        backgroundColor: "#dbbe8f",
                        backgroundOpacity: 1,
                        doodleImages: [
                            {
                                url: images.star_silver_1,
                                displaySize: {
                                    width: 50,
                                },
                                overflow: "visible",
                                style: {
                                    top: "-20px",
                                    left: "30px",
                                },
                            },
                            {
                                url: images.bubble_blue_1,
                                displaySize: { width: 14 },
                                overflow: "visible",
                                style: {
                                    top: "25px",
                                    left: "80px",
                                },
                            },
                            {
                                url: images.star_gold_1,
                                displaySize: { width: 80 },
                                overflow: "visible",
                                style: {
                                    right: "-10px",
                                    bottom: "-10px",
                                },
                            },
                            {
                                url: images.bubble_blue_1,
                                displaySize: { width: 14 },
                                overflow: "visible",
                                style: {
                                    right: "70px",
                                    bottom: "70px",
                                },
                            },
                            {
                                url: images.bubble_blue_1,
                                displaySize: {
                                    width: 20,
                                },
                                overflow: "visible",
                                style: {
                                    right: "70px",
                                    bottom: "10px",
                                },
                            },
                            {
                                url: images.bubble_gold_1,
                                displaySize: {
                                    width: 18,
                                },
                                overflow: "visible",
                                style: {
                                    right: "40px",
                                    bottom: "60px",
                                },
                            },
                        ],
                    },
                ],
            },
            overlay: {
                variant: "doodle",
                animate: {
                    rotate: 23,
                    translate: { x: 12, y: 6 },
                    scale: 1.2,
                },
                images: [
                    {
                        url: images.star_gold_1,
                        displaySize: {
                            width: 80,
                        },
                        style: {
                            top: "-30px",
                            left: "80px",
                        },
                    },
                    {
                        url: images.star_gold_2,
                        displaySize: {
                            width: 80,
                        },
                        style: {
                            right: "-30px",
                            bottom: "80px",
                        },
                    },
                    {
                        url: images.star_silver_1,
                        displaySize: {
                            width: 130,
                        },
                        style: {
                            right: "70px",
                            bottom: "-60px",
                        },
                    },
                ],
            },
            betweenTransition: {
                variant: "scale",
                timing: {
                    variant: "bezier",
                    config: bezierConfig,
                    durationSeconds: 0.5,
                },
            },
            title: {
                backgroundColor: "#fff",
                backgroundOpacity: 0.95,
                textColor: "#fff",
                fontFamily: "Stint Ultra Condensed",
                fontWeight: "normal",
                fontSize: 90,
                nudge: 2,
                textTransform: "none",
            },
            subtitle: {
                backgroundColor: "#fff",
                backgroundOpacity: 0.95,
                textColor: "#fff",
                fontFamily: "Stint Ultra Condensed",
                fontWeight: "normal",
                fontSize: 60,
                nudge: 2,
                textTransform: "uppercase",
            },
            scaleFactor: 0.9,
            borderRadius: "3rem",
            boxShadow: "0.25rem 0.25rem 1.125rem 0px rgba(0,0,0,0.75)",
            border: "0.25rem solid #232626",
        },
        watermark: {
            opacity: 0.8,
            margin: 32,
            enterTransition: {
                variant: "marginSlide",
                direction: "from-left",
                timing: { variant: "linear", durationSeconds: 0.5 },
            },
            exitTransition: {
                variant: "marginSlide",
                direction: "from-left",
                timing: { variant: "linear", durationSeconds: 0.5 },
            },
        },
        sceneTransition: {
            variant: "scale",
            timing: {
                variant: "bezier",
                config: bezierConfig,
                durationSeconds: 0.5,
            },
        },
    },
    userInputFields: [
        {
            id: "titleMessage",
            type: "text",
            label: "Title Message",
            defaultValue: "",
            placeholder: "Thank You, Jane!",
            required: true,
            min: 1,
            max: 35,
            preview: {
                sceneIndex: 0,
                frameOffset: 50,
            },
        },
    ],
    colorPalettes: ["StarPop"],
};
